import React, { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import { Col, Row } from "reactstrap";

const CountryStateCitySelect = ({ onLocationChange }) => {
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [isLoadingStates, setIsLoadingStates] = useState(false);
  const [isLoadingCities, setIsLoadingCities] = useState(false);

  // Obtener países (solo se ejecuta una vez al montar)
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch(
          "https://countriesnow.space/api/v0.1/countries"
        );
        const data = await response.json();
        if (data?.data) {
          setCountries(data.data);
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []); // <-- Array de dependencias vacío para que solo se ejecute una vez

  // Función para obtener estados
  const fetchStates = useCallback(async (country) => {
    if (!country) return;

    setIsLoadingStates(true);
    try {
      const response = await fetch(
        "https://countriesnow.space/api/v0.1/countries/states",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ country }),
        }
      );

      const data = await response.json();
      if (data?.data?.states) {
        setStates(data.data.states);
      } else {
        setStates([]);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
      setStates([]);
    } finally {
      setIsLoadingStates(false);
    }
    setCities([]);
    setSelectedState("");
    setSelectedCity("");
  }, []);

  // Función para obtener ciudades
  const fetchCities = useCallback(async (country, state) => {
    if (!country || !state) return;

    setIsLoadingCities(true);
    try {
      const response = await fetch(
        "https://countriesnow.space/api/v0.1/countries/state/cities",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ country, state }),
        }
      );

      const data = await response.json();
      if (data?.data) {
        setCities(data.data);
      } else {
        setCities([]);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
      setCities([]);
    } finally {
      setIsLoadingCities(false);
    }
    setSelectedCity("");
  }, []);

  // Manejar cambio de país
  useEffect(() => {
    if (selectedCountry) {
      fetchStates(selectedCountry);
    }
  }, [selectedCountry, fetchStates]);

  // Manejar cambio de estado
  useEffect(() => {
    if (selectedCountry && selectedState) {
      fetchCities(selectedCountry, selectedState);
    }
  }, [selectedState, selectedCountry, fetchCities]);

  // Notificar cambios al componente padre
  useEffect(() => {
    onLocationChange({
      country: selectedCountry,
      state: selectedState,
      city: selectedCity,
    });
  }, [selectedCountry, selectedState, selectedCity, onLocationChange]);
  const theme = useSelector((state) => state.theme.theme) || "light";

  return (
    <div className="location-select">
      {/* Selector de País */}
      <Select
        id="tipo_Contacto"
        name="tipo_Conatcto"
        options={
          Array.isArray(countries)
            ? countries.map((item) => ({
                label: item.country,
                value: item.country,
              }))
            : []
        }
        placeholder="Seleccione un País"
        onChange={(e) => setSelectedCountry(e.value)}
        autoFocus
        required
        styles={{
          control: (base) => ({
            ...base,
            backgroundColor: theme === "dark" ? "#2c2c2c" : "#fff",
            color: theme === "dark" ? "#c3cbe4" : "#000",
            borderColor: theme === "dark" ? "#3b3b3b" : "#e9ebec",
            cursor: "pointer",
            fontSize: "0.9rem",
            marginBottom: "8px",
          }),
          menu: (base) => ({
            ...base,
            backgroundColor: theme === "dark" ? "#242424" : "#fff",
            borderRadius: "8px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
          }),
          option: (base, { isFocused, isSelected }) => ({
            ...base,
            backgroundColor: isSelected
              ? theme === "dark"
                ? "#242424"
                : "#ccc"
              : isFocused
              ? theme === "dark"
                ? "#121212"
                : "#ddd"
              : "transparent",
            color: theme === "dark" ? "#c3cbe4" : "#000",
            padding: "10px",
            fontSize: "0.9rem",
            cursor: "pointer",
          }),
          singleValue: (base) => ({
            ...base,
            color: theme === "dark" ? "#c3cbe4" : "#000",
          }),
          
        }}
      />

      {/* <select
          value={selectedCountry}
          onChange={(e) => setSelectedCountry(e.target.value)}
          className="form-select"
        >
          <option value="">Selecciona un país</option>
          {countries.map((country) => (
            <option
              key={country.iso2 || country.country}
              value={country.country}
            >
              {country.country}
            </option>
          ))}
        </select> */}

      {/* Selector de Estado/Provincia */}
      {/* <div className="form-group">
        <label>Estado/Provincia:</label>
        <select
          value={selectedState}
          onChange={(e) => setSelectedState(e.target.value)}
          disabled={!selectedCountry || isLoadingStates}
        >
          <option value="">
            {isLoadingStates ? "Cargando..." : "Selecciona un estado"}
          </option>
          {states.map((state) => (
            <option key={state.state_code || state.name} value={state.name}>
              {state.name}
            </option>
          ))}
        </select>
      </div> */}

      <Select
        id="tipo_Contacto"
        name="tipo_Conatcto"
        options={
          Array.isArray(states)
            ? states.map((item) => ({
                label: item.name,
                value: item.name,
              }))
            : []
        }
        placeholder="Seleccione un Estado/Provincia"
        onChange={(e) => setSelectedState(e.value)}
        autoFocus
        required
        styles={{
          control: (base) => ({
            ...base,
            backgroundColor: theme === "dark" ? "#2c2c2c" : "#fff",
            color: theme === "dark" ? "#c3cbe4" : "#000",
            borderColor: theme === "dark" ? "#3b3b3b" : "#e9ebec",
            cursor: "pointer",
            fontSize: "0.9rem",
            marginBottom: "8px",
          }),
          menu: (base) => ({
            ...base,
            backgroundColor: theme === "dark" ? "#242424" : "#fff",
            borderRadius: "8px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
          }),
          option: (base, { isFocused, isSelected }) => ({
            ...base,
            backgroundColor: isSelected
              ? theme === "dark"
                ? "#242424"
                : "#ccc"
              : isFocused
              ? theme === "dark"
                ? "#121212"
                : "#ddd"
              : "transparent",
            color: theme === "dark" ? "#c3cbe4" : "#000",
            padding: "10px",
            fontSize: "0.9rem",
            cursor: "pointer",
          }),
          singleValue: (base) => ({
            ...base,
            color: theme === "dark" ? "#c3cbe4" : "#000",
          }),
        }}
      />

      {/* Selector de Ciudad */}
      {/* <div className="form-group">
        <label>Ciudad:</label>
        <select
          value={selectedCity}
          onChange={(e) => setSelectedCity(e.target.value)}
          disabled={!selectedState || isLoadingCities}
        >
          <option value="">
            {isLoadingCities ? "Cargando..." : "Selecciona una ciudad"}
          </option>
          {cities.map((city, index) => (
            <option key={`${city}-${index}`} value={city}>
              {city}
            </option>
          ))}
        </select>
      </div> */}

      <Select
        id="tipo_Contacto"
        name="tipo_Conatcto"
        options={
          Array.isArray(cities)
            ? cities.map((city) => ({
                label: city,
                value: city,
              }))
            : []
        }
        placeholder="Seleccione un Ciudad"
        onChange={(e) => setSelectedCity(e.value)}
        autoFocus
        required
        styles={{
          control: (base) => ({
            ...base,
            backgroundColor: theme === "dark" ? "#2c2c2c" : "#fff",
            color: theme === "dark" ? "#c3cbe4" : "#000",
            borderColor: theme === "dark" ? "#3b3b3b" : "#e9ebec",
            cursor: "pointer",
            fontSize: "0.9rem",
          }),
          menu: (base) => ({
            ...base,
            backgroundColor: theme === "dark" ? "#242424" : "#fff",
            borderRadius: "8px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
          }),
          option: (base, { isFocused, isSelected }) => ({
            ...base,
            backgroundColor: isSelected
              ? theme === "dark"
                ? "#242424"
                : "#ccc"
              : isFocused
              ? theme === "dark"
                ? "#121212"
                : "#ddd"
              : "transparent",
            color: theme === "dark" ? "#c3cbe4" : "#000",
            padding: "10px",
            fontSize: "0.9rem",
            cursor: "pointer",
          }),
          singleValue: (base) => ({
            ...base,
            color: theme === "dark" ? "#c3cbe4" : "#000",
          }),
        }}
      />
    </div>
  );
};

export default CountryStateCitySelect;
